export default __webpack_public_path__ + "static/media/radar_label.03fa0cc6.png";